export default {
  STOCK: '证券账户',
  FUTURES: '期货账户',
  FOREX: '外汇账户',
  IB: 'EddidPro账户',
  PM: '现货黄金账户',
  accountInfo: '账户信息',
  transId: '交易单号',
  search: '搜索',
  export: '导出',
  clientAccount: '客户账号',
  transDate: '交易日期',
  valueDate: '结算日期',
  productName: '产品名称',
  number: '数量',
  tranAmount: '交易金额',
  commission: '佣金',
  market: '市场',
  orderType: '订单类型',
  avgPrice: '买入／卖出价',
  selectStartTime: '请选择开始日期',
  selectEndTime: '请选择结束日期',
  selectTimeError: '结束时间不能小于开始时间',
  B: '买入',
  S: '卖出',
  noData: '无交易记录'
}
